import { Radio } from "antd";
import "./styles.css";
import { useEffect, useState } from "react";
import { getQuestionResponseColor } from "../../../Utils/color_utils";
import CheckBoxCard from "./CheckBoxCard/CheckBoxCard";
import maleBodyThumbnail from "../../BodyMap/images/male-thumbnail.png";
import femaleBodyThumbnail from "../../BodyMap/images/female-thumbnail.png";
import { useSelector } from "react-redux";

export const QuestionSelection = ({ question, handleAnswer, answer }) => {

  const {
    info: { gender: gender }
  } = useSelector(({ team }) => team);
  
  const handleAnswerRadioClick = (answerValue, answerText) => {
    let answerForQuestion = {
      questionId: question.question_id,
      question: question.question,
      answer: answerValue,
      request: answer.request,
      answerText: answerText,
    };
    handleAnswer(answerForQuestion);
  };

  const handleToggleCheck = (checked) => {
    let answerForQuestion = {
      questionId: question.question_id,
      question: question.question,
      answer: question.answer,
      request: checked,
      answerText: question.answerText,
    };
    handleAnswer(answerForQuestion);
  };

  return (
    <CheckBoxCard
      defaultValue={answer?.request || false}
      title={question.question}
      handleCheckAnswerClick={handleToggleCheck}
    >
      <div className="answer-selection">
        {question.answers.length ? (
          <Radio.Group name="radiogroup" value={answer?.answer || false}>
            {question.answers.map((answer, index) => {
              let color = getQuestionResponseColor(question, answer.value);
              return (
                <>
                  <Radio
                    key={`${answer.value}${index}`} // Add unique key
                    value={answer.value}
                    style={{ color: color }}
                    onChange={() =>
                      handleAnswerRadioClick(answer.value, answer.answer)
                    }
                  >
                    {answer.answer
                      ? answer.answer
                      : "User will type in response."}
                  </Radio>
                  <br />
                </>
              );
            })}
          </Radio.Group>
        ) : (
          "User will type in response."
        )}
        {question.answer_type_id == 5 && 
          <img 
            className="body-logo" 
            src={gender == 'male' ? maleBodyThumbnail : femaleBodyThumbnail} 
            alt="body-thumbnail" 
          />}
        
      </div>
    </CheckBoxCard>
  );
};
